import Monitoring from './ui/Monitoring';

export default Monitoring;
